import { render, staticRenderFns } from "./CredentialCard.vue?vue&type=template&id=3538268c&"
import script from "./CredentialCard.vue?vue&type=script&lang=js&"
export * from "./CredentialCard.vue?vue&type=script&lang=js&"
import style0 from "./CredentialCard.vue?vue&type=style&index=0&lang=scss&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports